/** The Cognito groups the Stripe webhook puts a paying user in (backend
 *  stripe_webhook_service.py PAID_GROUPS): Pilot is Pro, Starter has fewer seats. */
export const PAID_GROUPS = ["Pilot", "Starter"] as const
